import * as importedButton from "@interstate/components/Button";
import type { ButtonProps } from "@interstate/components/Button";
import type { coreEventProperties } from "@dealer-center/core-interfaces-third-party-gtm";
import { TagManager } from "@dealer-center/core-third-party-gtm";

export interface ButtonInterface extends ButtonProps {
  analyticsConfiguration: {
    eventName: string;
    eventProperties?: coreEventProperties;
  };
}

export const Button = ({
  onClick,
  analyticsConfiguration,
  ...props
}: ButtonInterface) => {
  return (
    <importedButton.Button
      {...props}
      onClick={interstateEvent => {
        if (analyticsConfiguration) {
          TagManager.event({
            eventName: analyticsConfiguration.eventName,
            eventProperties: analyticsConfiguration.eventProperties
          });
        }
        if (onClick) {
          onClick(interstateEvent);
        }
      }}
    />
  );
};
